// ABOUTME: Informational block showing the amazon_stockhub subscription prices in the add-webshop flow.
// ABOUTME: Display-only; the amazon subscription is auto-created by the backend when the credential is created.

import { Box, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { tokens } from '../../../../../theme';
import { formatPrice } from '../../../../../utils/helpers';
import Text from '../../../../theme/text/Text';
import { useGetSubscriptionPricesQuery } from '../../../../../newapi/subscription/subscriptionSlice';

const PriceLine = ({ label, price, i18n, t }) => {
    const configured = price !== null && price !== undefined;
    return (
        <Box sx={{ display: 'flex', alignItems: 'baseline', justifyContent: 'space-between', gap: 2 }}>
            <Text light>{label}</Text>
            <Text>{configured ? formatPrice(i18n, price) : t('subscription_price_not_configured')}</Text>
        </Box>
    );
};

const AmazonSubscriptionInfo = () => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const { t, i18n } = useTranslation();

    const { data: prices } = useGetSubscriptionPricesQuery('amazon');
    const pricesConfigured = !!prices
        && prices.monthly !== null && prices.monthly !== undefined
        && prices.order !== null && prices.order !== undefined;

    return (
        <Box
            sx={{
                width: 1,
                mt: 2,
                p: 2,
                borderRadius: 4,
                backgroundColor: theme.palette.mode === 'dark' ? colors.grey[300] : colors.grey[100],
                display: 'flex',
                flexDirection: 'column',
                gap: 1,
            }}
        >
            <Text bold>{t('amazon_subscription')}</Text>
            <PriceLine label={t('amazon_subscription_per_month')} price={prices?.monthly} i18n={i18n} t={t} />
            <PriceLine label={t('amazon_subscription_per_order')} price={prices?.order} i18n={i18n} t={t} />
            {!pricesConfigured && (
                <Text sx={{ color: colors.red[400] }}>{t('amazon_prices_not_configured_blocked')}</Text>
            )}
        </Box>
    );
};

export default AmazonSubscriptionInfo;
